import { Box, Icon } from '@alto-avios/alto-ui';
import { FC, useState } from 'react';

import { MaintenanceBannerData } from '../services/content';
import { Markdown } from '../Markdown';

import styles from './MaintenanceBanner.module.css';

export const MaintenanceBanner: FC<MaintenanceBannerData> = ({ text, moreText, seeMoreLabel, seeLessLabel }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const toggleContent = () => setIsExpanded(!isExpanded);
  const hasMoreText = moreText && seeMoreLabel && seeLessLabel;

  return (
    text && (
      <div className={styles.notificationsBannerContainer} data-testid="maintenance-banner">
        <div className={styles.iconWrapper}>
          <Icon iconName="info-circle" iconPrefix="far" iconSize="1x" />
        </div>
        <Box flexDirection="column">
          <Markdown overrideForegroundColor="default">{text}</Markdown>
          {isExpanded && <Markdown overrideForegroundColor="default">{moreText}</Markdown>}
          {hasMoreText && (
            <button className={styles.button} onClick={toggleContent} aria-expanded={isExpanded}>
              {isExpanded ? seeLessLabel : seeMoreLabel}
            </button>
          )}
        </Box>
      </div>
    )
  );
};
